import { Pipe, PipeTransform } from '@angular/core';
import { Platform } from '../models/inModels/app-release.model';

@Pipe({name: 'platformName'})
export class PlatformNamePipe implements PipeTransform {
  transform(value: number): string {
    return Platform[value] || 'Unknown';
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/platformName.pipe.ts